import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import util from '../../common/util';

@Component
export default class UserInfoComponent extends Vue {
    editFormVisible: Boolean = false;//编辑界面是否显示
    editLoading: Boolean = false;
    userInfo: any = {};//用户信息
    fileList: Array<any> = [];
    $refs: {
        editForm: Form,
    };
    editForm = {
        password: '',
        checkPassword: ''
    };
    accountType: string = '';//账号类型

    //编辑界面校验规则
    editFormRules = {
        password: [
            {
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入密码'));
                    } else if (value != JSON.parse(localStorage.getItem('access-user')).password) {
                        callback(new Error('旧密码输入错误'));
                    } else if (!/^[^\s]{6,20}$/.test(value)) {
                        callback(new Error('请输入6-20位字符，英文字母大小写、数字及字符（不能有空格）'));
                    } else {
                        callback();
                    }
                },
                required: true,
                trigger: 'blur'
            }
        ],
        checkPassword: [
            {
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入密码'));
                    } else if (!/^[^\s]{6,20}$/.test(value)) {
                        callback(new Error('请输入6-20位字符，英文字母大小写、数字及字符（不能有空格）'));
                    } else {
                        callback();
                    }
                },
                required: true,
                trigger: 'blur'
            }
        ],
    }

    //获取用户信息
    getUserInfo() {
        this.axios.get('/api/personalcenter').then((data) => {
            let datas = data.data;
            this.userInfo = datas;
        })
    }

    //显示编辑界面
    showEditDialog() {
        this.editFormVisible = true;
    }
    //取消编辑
    cancelSubmit() {
        this.editFormVisible = false;
    }
    //编辑功能
    editSubmit() {
        this.$refs.editForm.validate((valid) => {
            if (valid) {
                let para = (<any>Object).assign({}, this.editForm);
                this.$confirm('确认提交吗？', '提示', {}).then(() => {
                    this.editLoading = true;
                    this.axios.put('/api/personalcenter/' + this.userInfo.accountId + '?oldPassWord=' + para.password + '&newPassword=' + para.checkPassword).then((data) => {
                        this.editLoading = false;
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.$refs['editForm'].resetFields();
                        this.editFormVisible = false;
                    })
                })
            }
        });
    }
    
    
    mounted() {
        this.accountType = JSON.parse(localStorage.getItem('access-user')).accountType;
        this.getUserInfo();
    }
}
